import React, {Component} from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Auftrag from '../containers/auftrag';
import Success from '../containers/success';
import NotFound from '../containers/404';

class Routes extends Component {
    render() {
        return (
                <Switch>
                    <Route exact path='/' component={Auftrag}/>
                    <Route exact path='/Success' component={Success}/>
                    <Route path='*' component={NotFound}/>
                </Switch>
        );
    }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.js